import { ImageSize, setImageQuality } from '@utils/Image.utils';
import { useMemo } from 'react';

export const useSetImageQuality = (url: string = '', quality: ImageSize = ImageSize.MEDIUM) =>
    useMemo(() => setImageQuality(url, quality), [url]);
